import { createSelector } from 'reselect'

const selectCashBuyers = (state) => state.get('cashbuyers')

export const getSubjectProperty = createSelector(selectCashBuyers, (s) => s.get('subjectProperty'))
export const getRadius = createSelector(selectCashBuyers, (s) => s.get('radius'))
export const getTake = createSelector(selectCashBuyers, (s) => s.get('take'))
export const getClassifications = createSelector(selectCashBuyers, (s) => (s.get('classifications')?.toJS?.() || []))
export const getPropertyTypes = createSelector(selectCashBuyers, (s) => (s.get('propertyTypes')?.toJS?.() || []))
export const getInvestors = createSelector(selectCashBuyers, (s) => s.get('investors'))
export const getProperties = createSelector(selectCashBuyers, (s) => s.get('properties'))
export const getMeta = createSelector(selectCashBuyers, (s) => s.get('meta'))
export const getSelectedInvestorId = createSelector(selectCashBuyers, (s) => s.get('selectedInvestorId'))
export const getCheckedInvestorIds = createSelector(selectCashBuyers, (s) => (s.get('checkedInvestorIds')?.toJS?.() || []))
export const getSortBy = createSelector(selectCashBuyers, (s) => s.get('sortBy'))
export const getLoading = createSelector(selectCashBuyers, (s) => s.get('loading'))
export const getError = createSelector(selectCashBuyers, (s) => s.get('error'))
export const getSubjectCoords = createSelector(selectCashBuyers, (s) => s.get('subjectCoords'))
